import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import { SxProps, Theme } from '@mui/material/styles';
import mergeSx from 'utils/mergeSx';

interface Props {
  /** External/protocol link (tel:, mailto:, https:) */
  href?: string;
  /** Internal route (react-router) */
  to?: string;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

const OrangeButton: FC<Props> = ({ href, to, sx, children }) => (
  <Box
    component={to ? RouterLink : 'a'}
    to={to}
    href={href}
    sx={mergeSx(
      {
        typography: 'body1',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        bgcolor: 'staticPages.orange',
        px: 3.5,
        py: 1.5,
        borderRadius: 3,
        fontWeight: 600,
        color: 'common.white',
        textDecoration: 'none',
        '&:hover': { filter: 'brightness(1.04)' },
      },
      sx,
    )}
  >
    {children}
  </Box>
);

export default OrangeButton;
